<div class="mb-3 flex items-start justify-between gap-3">
  <div>
    <h3 class="text-lg font-semibold">{{ titleKey() | transloco: titleParams() }}</h3>
    @if (subtitleKey()) {
      <p class="text-muted-color text-sm">{{ subtitleKey() | transloco }}</p>
    }
  </div>
  <ng-content />
</div>
